import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { Reveal } from "./Reveal";

export function CtaBanner({ title, sub, btn1, btn2, to1, to2, id = "cta-banner" }) {
  return (
    <section className="container-x py-20 lg:py-28" data-testid={id}>
      <Reveal>
        <div className="grain relative overflow-hidden rounded-[2.5rem] bg-navy px-8 py-16 text-white sm:px-14 lg:px-20 lg:py-20">
          <div className="pointer-events-none absolute -right-20 -top-20 h-80 w-80 rounded-full bg-teal-500/30 blur-[100px]" />
          <div className="pointer-events-none absolute -bottom-24 left-1/3 h-72 w-72 rounded-full bg-sky-500/30 blur-[100px]" />
          <div className="relative grid items-end gap-10 lg:grid-cols-12">
            <div className="lg:col-span-8">
              <h2 className="font-display text-3xl font-bold leading-[1.05] sm:text-4xl lg:text-5xl">{title}</h2>
              <p className="mt-5 max-w-xl text-base text-slate-300 md:text-lg">{sub}</p>
            </div>
            <div className="flex flex-wrap gap-4 lg:col-span-4 lg:justify-end">
              <Link to={to1} className="btn-light" data-testid={`${id}-primary`}>{btn1} <ArrowRight size={16} /></Link>
              {btn2 && <Link to={to2 || to1} className="btn-outline-light" data-testid={`${id}-secondary`}>{btn2}</Link>}
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}

export function PageHero({ eyebrow, title, sub, id }) {
  return (
    <section className="relative overflow-hidden bg-[#F8FAFC] pb-16 pt-36 lg:pb-24 lg:pt-44" data-testid={`${id}-hero`}>
      <div className="pointer-events-none absolute -left-32 top-0 h-[420px] w-[420px] rounded-full bg-teal-200/40 blur-[120px]" />
      <div className="pointer-events-none absolute -right-20 top-20 h-[360px] w-[360px] rounded-full bg-sky-200/50 blur-[120px]" />
      <div className="container-x relative max-w-4xl">
        <Reveal y={20}>
          <p className="eyebrow">{eyebrow}</p>
          <h1 className="mt-5 font-display text-4xl font-extrabold leading-[1.05] text-slate-900 sm:text-5xl lg:text-6xl" data-testid={`${id}-title`}>{title}</h1>
          {sub && <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-600 md:text-lg">{sub}</p>}
        </Reveal>
      </div>
    </section>
  );
}

export function useLangCta() {
  const { t, to } = useLang();
  return { t, to };
}
